module.exports = "/assets/dist/images/bodystyles_sedans.png?22cf9a7bfb151e9e6262e52d6f07e2c6";